import { customerId, jwtToken } from 'data/mock-data';

const mock = () => ({
  data: {
    customerId,
    jwtToken,
  },
});

export default mock;
